import { Pagination } from '@anyemp/ui-kit'
import { PAGINATION_OPTIONS } from '../../utils/paginationConstants'
import { getTalentListPaginationClassName } from '../../utils/paginationPresentation'

const TalentListPagination = ({ pagination, limit, onPageChange, onLimitChange, sticky = false }) => (
  <div className={getTalentListPaginationClassName(sticky)}>
    <Pagination
      currentPage={pagination.current_page}
      totalPages={pagination.total_pages}
      totalItems={pagination.total_items}
      itemsPerPage={pagination.items_per_page}
      onPageChange={onPageChange}
      showResults="range"
      perPageOptions={PAGINATION_OPTIONS}
      perPage={limit}
      onPerPageChange={(value) => onLimitChange(parseInt(value, 10))}
      showOnSinglePage
      hasFirstLast
      hasGoToPage
    />
  </div>
)

export default TalentListPagination
